import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap';
import { AppConfigService } from '../app.config';
import { DisplayModes } from '../models/enums';
import { Permission } from '../models/permission.model';
import { AccountService } from '../services/account.service';
import { AlertService, MessageSeverity } from '../services/alert.service';
import { AppTranslationService } from '../services/app-translation.service';
import { AgreementService } from './agreement.service';



@Component({
  selector: 'crm-agreement',
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.css']
})
export class AgreementComponent implements OnInit {

  agreements: any[] = [];
  displayMode: DisplayModes = DisplayModes.Success;
  searchText: string;
  pageSize: number;
  public logo = require("../../app/assets/images/demo/Icon_Items Format.png");

  selectedAgreementId;
  addNew: boolean = false;
  @ViewChild('deleteModal')
  deleteModal: ModalDirective;
  constructor(private readonly router: Router,
    private readonly alertService: AlertService,
    private readonly translateService: AppTranslationService,
    private readonly appConfig: AppConfigService,
    private readonly agreementService: AgreementService,
    private accountService: AccountService) { }

  ngOnInit() {
    this.pageSize = this.appConfig.settings.pageSize;
    this.getAgreements();
  }

  getAgreements() {
    this.displayMode = DisplayModes.Loading;
    this.agreementService.getAll().subscribe(responce => {
      this.agreements = responce as any[];
      this.displayMode = DisplayModes.Success;
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get agreements');
        console.log(err);
      })

  }

  gotoNew() {
    this.addNew = true;
  }

  edit(id) {
    this.selectedAgreementId = id;
    this.addNew = true;
  }

  confirmDelete(itemFormat) {
    this.selectedAgreementId = itemFormat;
    this.deleteModal.show();
  }

  delete() {
    this.hideDeleteModal();
    this.displayMode = DisplayModes.Loading;
    this.agreementService.delete(this.selectedAgreementId.id).subscribe(response => {
      this.displayMode = DisplayModes.Success;
      this.alertService.showMessage("", this.translateService.getTranslation("clm.deletedSuccessfully"), MessageSeverity.Success);

      let index = this.agreements.indexOf(this.selectedAgreementId);
      this.agreements.splice(index, 1);
    }, error => {
      this.displayMode = DisplayModes.Error;
      this.alertService.showStickyMessage("Save Error", "The below errors occured while delete item fromat:", MessageSeverity.Error, error);
      this.alertService.showStickyMessage(error, null, MessageSeverity.Error);
    });
  }

  get canAddAgreements() {
    return this.accountService.userHasPermission(Permission.addAgreementsPermission);
  }
  get canEditAgreements() {
    return this.accountService.userHasPermission(Permission.editAgreementsPermission);
  }
  get canDeleteAgreements() {
    return this.accountService.userHasPermission(Permission.deleteAgreementsPermission);
  }


  closeAdding(event) {
    this.selectedAgreementId = undefined;
    this.addNew = false;
    if (event) {
      this.getAgreements();
    }
  }

  hideDeleteModal() {
    this.deleteModal.hide();
  }

   getAgreementYear(event) {
     return new Date(event.agreementDate).getFullYear();
  }

}
